/** Copy-paste example shown in the Image Build wizard (keep in sync with docs/examples/image-values.yaml). */
export const IMAGE_VALUES_EXAMPLE = `version: 1

build:
  image_version: "0.8.1"
  gcp_project_id: redislabs-sa-training-services
  gcp_region: us-east1
  gcp_zone: us-east1-b
  disk_size: 100

launch:
  port: 80
  machine_type: e2-standard-4
  expiration_days: 5
  expiration_hours: 0
  ssh_username: ubuntu
`;
